// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"Info_TheComp__fy8yq"};